import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	DatePicker,
	Segmented,
	Table,
	Statistic,
	Button,
	Row,
	Col,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
const { Text, Title } = Typography;
const { RangePicker } = DatePicker;

const lineupColumns = [
	{ key: "driver", label: "Driver" },
	{ key: "truck", label: "Truck" },
	{ key: "yards", label: "Yards" },
	{ key: "date2", label: "Date" },
	{ key: "customer", label: "Customer" },
	{ key: "jobNumber", label: "Job ID" },
	{ key: "deliveryTicket", label: "Ticket" },
	{ key: "orderCode", label: "Order Code" },
	{ key: "sequence", label: "Sequence" },
];

const LineupRange = () => {
	const [loading, setLoading] = useState(true);
	const [jobListMission1, setJobListMission1] = useState([]);
	const [jobListMission2, setJobListMission2] = useState([]);
	const [jobListSanBenito1, setJobListSanBenito1] = useState([]);
	const [jobListBrownsville1, setJobListBrownsville1] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [currentTable, setCurrentTable] = useState("mission1");
	const [minutesMission1, setMinutesMission1] = useState(0);
	const [minutesMission2, setMinutesMission2] = useState(0);
	const [minutesSanBenito1, setMinutesSanBenito1] = useState(0);
	const [minutesBrownsville1, setMinutesBrownsville1] = useState(0);
	const [timeMinutes, setTimeMinutes] = useState(0);
	const refDownload = useRef();

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "YD3",
			dataIndex: "yards",
			key: "yards",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return (
					<Text>{`${dayjs(value).toDate().toLocaleDateString()} - ${dayjs(value)
						.toDate()
						.toLocaleTimeString([], { timeStyle: "short" })}`}</Text>
				);
			},
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Job ID",
			dataIndex: "jobNumber",
			key: "jobNumber",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Ticket",
			dataIndex: "deliveryTicket",
			key: "deliveryTicket",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Order Code",
			dataIndex: "orderCode",
			key: "orderCode",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Sequence",
			dataIndex: "sequence",
			key: "sequence",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getLoadList(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
	}, []);

	const getLoadList = async (start, end) => {
		setLoading(true);
		const url = api + `/loaddaterange?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.map((item, index) => {
				list.push({
					key: index,
					id: item._id,
					sequence: item.sequence,
					driver: item.driver,
					truck: item.truckNumber,
					orderCode: item.orderCode,
					yards: item.yards,
					deliveryTicket: item.deliveryTicket,
					date: item.createdAt,
					plant: item.job.plant.name,
					subplant: item.job.subplant ? item.job.subplant : "-",
					customer: item.job.customer.name,
					jobNumber: item.job.number,
					date2: `${dayjs(item.createdAt)
						.toDate()
						.toLocaleDateString()} - ${dayjs(item.createdAt)
						.toDate()
						.toLocaleTimeString([], { timeStyle: "short" })}`,
				});
			});

			let currentHours1 = 0;
			let plant1 = list.filter(
				(job) => job.plant === "Mission" && job.subplant === "P1",
			);
			for (let index = 0; index < plant1.length - 1; index++) {
				const element = plant1[index];
				const element2 = plant1[index + 1];
				currentHours1 +=
					Math.abs(new Date(element.date) - new Date(element2.date)) / 36e5;
			}
			let minutes1 = (currentHours1 / plant1.length) * 60;
			setMinutesMission1(minutes1 || 0);

			let currentHours2 = 0;
			let plant2 = list.filter(
				(job) => job.plant === "Mission" && job.subplant === "P2",
			);
			for (let index = 0; index < plant2.length - 1; index++) {
				const element = plant2[index];
				const element2 = plant2[index + 1];
				currentHours2 +=
					Math.abs(new Date(element.date) - new Date(element2.date)) / 36e5;
			}
			let minutes2 = (currentHours2 / plant2.length) * 60;
			setMinutesMission2(minutes2 || 0);

			let currentHours3 = 0;
			let plant3 = list.filter((job) => job.plant === "San Benito");

			for (let index = 0; index < plant3.length - 1; index++) {
				const element = plant3[index];
				const element2 = plant3[index + 1];
				currentHours3 +=
					Math.abs(new Date(element.date) - new Date(element2.date)) / 36e5;
			}
			let minutes3 = (currentHours3 / plant3.length) * 60;
			setMinutesSanBenito1(minutes3 || 0);

			let currentHours4 = 0;
			let plant4 = list.filter((job) => job.plant === "Brownsville");

			for (let index = 0; index < plant4.length - 1; index++) {
				const element = plant4[index];
				const element2 = plant4[index + 1];
				currentHours4 +=
					Math.abs(new Date(element.date) - new Date(element2.date)) / 36e5;
			}
			let minutes4 = (currentHours4 / plant4.length) * 60;
			setMinutesBrownsville1(minutes4 || 0);

			setTimeMinutes(minutes1 || 0);

			plant1.forEach((row, index) => {
				row.sequence = index + 1;
				return row;
			});
			plant2.forEach((row, index) => {
				row.sequence = index + 1;
				return row;
			});
			plant3.forEach((row, index) => {
				row.sequence = index + 1;
				return row;
			});
			plant4.forEach((row, index) => {
				row.sequence = index + 1;
				return row;
			});

			plant1.sort((a, b) => b.sequence - a.sequence);
			plant2.sort((a, b) => b.sequence - a.sequence);
			plant3.sort((a, b) => b.sequence - a.sequence);
			plant4.sort((a, b) => b.sequence - a.sequence);

			setJobListMission1(plant1);
			setJobListMission2(plant2);
			setJobListSanBenito1(plant3);
			setJobListBrownsville1(plant4);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onChangeSegment = (value) => {
		setCurrentTable(value);
		if (value === "mission1") setTimeMinutes(minutesMission1);
		if (value === "mission2") setTimeMinutes(minutesMission2);
		if (value === "sanbenito1") setTimeMinutes(minutesSanBenito1);
		if (value === "brownsville1") setTimeMinutes(minutesBrownsville1);
	};

	const RenderTable = () => {
		return (
			<Flex gap="large" justify="center" vertical>
				<Statistic
					title="Average Time"
					value={timeMinutes}
					precision={0}
					suffix={"minutes"}
				/>
				<Flex gap="small" align="center" vertical>
					<Segmented
						onChange={onChangeSegment}
						value={currentTable}
						options={[
							{
								label: (
									<div style={{ padding: 20 }}>
										<Title level={2}>Mission Plant</Title>
										<Text style={{ fontSize: 20 }} strong>
											Subplant P1
										</Text>
									</div>
								),
								value: "mission1",
							},
							{
								label: (
									<div style={{ padding: 20 }}>
										<Title level={2}>Mission Plant</Title>
										<Text style={{ fontSize: 20 }} strong>
											Subplant P2
										</Text>
									</div>
								),
								value: "mission2",
							},
							{
								label: (
									<div style={{ padding: 20 }}>
										<Title level={2}>San Benito Plant</Title>
										<Text style={{ fontSize: 20 }} strong>
											Subplant P1
										</Text>
									</div>
								),
								value: "sanbenito1",
							},
							{
								label: (
									<div style={{ padding: 20 }}>
										<Title level={2}>Brownsville Plant</Title>
										<Text style={{ fontSize: 20 }} strong>
											Subplant P1
										</Text>
									</div>
								),
								value: "brownsville1",
							},
						]}
					/>
				</Flex>
				{currentTable === "mission1" && (
					<Table
						columns={columns}
						dataSource={jobListMission1}
						pagination={{
							defaultPageSize: 10,
							showSizeChanger: true,
							pageSizeOptions: ["10", "30", "50", "100"],
						}}
					/>
				)}
				{currentTable === "mission2" && (
					<Table
						columns={columns}
						dataSource={jobListMission2}
						pagination={{
							defaultPageSize: 10,
							showSizeChanger: true,
							pageSizeOptions: ["10", "30", "50", "100"],
						}}
					/>
				)}
				{currentTable === "sanbenito1" && (
					<Table
						columns={columns}
						dataSource={jobListSanBenito1}
						pagination={{
							defaultPageSize: 10,
							showSizeChanger: true,
							pageSizeOptions: ["10", "30", "50", "100"],
						}}
					/>
				)}
				{currentTable === "brownsville1" && (
					<Table
						columns={columns}
						dataSource={jobListBrownsville1}
						pagination={{
							defaultPageSize: 10,
							showSizeChanger: true,
							pageSizeOptions: ["10", "30", "50", "100"],
						}}
					/>
				)}
			</Flex>
		);
	};

	const onChangeRange = (dates) => {
		if (!dates) return;
		setStartDate(dates[0]);
		setEndDate(dates[1]);
		getLoadList(dates[0].format("YYYY-MM-DD"), dates[1].format("YYYY-MM-DD"));
	};

	const RenderDate = () => (
		<RangePicker
			value={[startDate, endDate]}
			format={"MM/DD/YYYY"}
			onChange={onChangeRange}
			size="large"
			allowClear={false}
		/>
	);

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={
						currentTable === "mission1"
							? jobListMission1
							: currentTable === "mission2"
								? jobListMission2
								: currentTable === "sanbenito1"
									? jobListSanBenito1
									: jobListBrownsville1
					}
					headers={lineupColumns}
					filename={"57concrete-lineup-range.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
						>
							Download Report{" "}
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout title="Lineup Range" description="Load List by Date Range">
			<Flex vertical gap={"small"}>
				<RenderDate />
				{loading ? <CustomSpinner /> : <RenderTable />}
				<RenderDownloadReport />
			</Flex>
		</Layout>
	);
};

export default LineupRange;
